const constants = {
    STATUS_COMPLETE: 'Completo',
    CACHE_EXPIRES: 1,
    CONST_LANGUAGE_PATH: 'assets/languages/language.json',
    CONST_LANGUAGE_CACHE_NAME: 'lang_2025_2'
};

export default constants;